var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('span',{class:_vm.pouce_up,on:{"click":function($event){return _vm.submit(1)}}},[_vm._v("thumb_up")]),_c('span',{class:_vm.pouce_down,on:{"click":function($event){return _vm.submit(-1)}}},[_vm._v("thumb_down")])])
}
var staticRenderFns = []

export { render, staticRenderFns }